import { useLocalization } from "@fluent/react";
import { useGetPersonalLoanProductsQuery } from "@lending/hooks/queries/PersonalLoanProduct/useGetPersonalLoanProductsQuery";
import { SelectedProductTag } from "./SelectedProductTag";
import { useStore } from "../../contexts/StoreContext";

export function PersonalLoanSelectedProductTag() {
  const { l10n } = useLocalization();
  const { data } = useStore();
  const { personalLoanProductsData } = useGetPersonalLoanProductsQuery();

  if (!personalLoanProductsData) {
    return null;
  }

  const selectedProduct = personalLoanProductsData.results.find(
    (product) => product.uuid === data.selectedProduct
  );

  const productName =
    selectedProduct?.name ??
    l10n.getString("product-selection-personal-loan-name", null, "Personal loan");

  return <SelectedProductTag productName={productName} />;
}
